export default __webpack_public_path__ + "static/media/pic16-1.5bd32441.jpg";